import { fetchOpts } from 'apis/mafia';
import timedFetch from 'middleware/timedFetch';

/** Submit a user review without media. */
export async function submitReview(cloudReviewsUrl, credentials, params, fetcher = timedFetch('submitReview')) {
  const url = `${cloudReviewsUrl}/accountapi/n/cloudreviews/v1/submit`;
  const optsPlusMafiaAuthOpts = fetchOpts({
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params)
  }, credentials);
  return fetcher(url, optsPlusMafiaAuthOpts);
}

/** Upload user media. */
export async function submitMedia(cloudReviewsUrl, credentials, params, fetcher = timedFetch('submitMedia')) {
  const url = `${cloudReviewsUrl}/v1/media`;
  const optsPlusMafiaAuthOpts = fetchOpts({
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params)
  }, credentials);
  return fetcher(url, optsPlusMafiaAuthOpts);
}

/** Upvote a review. */
export async function upvoteReview(cloudReviewsUrl, credentials, reviewId, fetcher = timedFetch('upvoteReview')) {
  const url = `${cloudReviewsUrl}/accountapi/n/cloudreviews/v1/upvote`;
  const optsPlusMafiaAuthOpts = fetchOpts({
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ reviewId })
  }, credentials);
  return fetcher(url, optsPlusMafiaAuthOpts);
}
